import RichText from '@/components/RichText'
import UnknownComponent from '@/components/UnknownComponent'
import type { WpHomepage as WpHomepageModel } from '@/kontent/content-types/wp_homepage'
import type { CommonPageProps } from '@/types'
import { isRichtextElementEmpty } from '@/utils'

function WpHomepage(props: CommonPageProps<WpHomepageModel>) {
	const { mappings, data } = props
	const { pageResponse } = data
	const page = pageResponse.item

	if (!page) {
		return (
			<UnknownComponent>Page does not have any content!</UnknownComponent>
		)
	}

	return (
		<>
			{!isRichtextElementEmpty(page.elements.content_panel) && (
				<RichText
					className="w-full [&>*+*]:!mt-0"
					mappings={mappings}
					linkedItems={pageResponse.linkedItems}
					richTextElement={page.elements.content_panel}
				/>
			)}

			{/* <section className="nsw-section">
				<GridWrapper>
					{getLinkedItems(
						page.elements.links,
						pageResponse.linkedItems,
					).map((homepageAdditionalLinkList) => (
						<GridCol
							key={homepageAdditionalLinkList.system.codename}
							lg={12}
						>
							<div className="p-4">
								<h3>
									{
										homepageAdditionalLinkList.elements
											.title.value
									}
								</h3>
								<div
									css={{
										'& .nsw-link-list.nsw-link-list': {
											marginTop: '1rem',
										},
									}}
								>
									<PureUiLinkList
										linkedItem={homepageAdditionalLinkList}
										mappings={mappings}
									></PureUiLinkList>
								</div>
							</div>
						</GridCol>
					))}
				</GridWrapper>
			</section> */}
		</>
	)
}

export default WpHomepage
